// services/publicBlogApi.js
// Public Editor Blog API Service (FINAL FIXED VERSION)

const BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001/api";
const PUBLIC_BLOGS = `${BASE}/v1/public/blogs`;

/* ─────────────────────────────────────────────
   🔧 INTERNAL UTIL: SLUG NORMALIZER
   Fixes unicode dash + spaces + casing
───────────────────────────────────────────── */
function normalizeSlug(slug = "") {
  return decodeURIComponent(slug)
    .replace(/[—–]/g, "-")       // normalize unicode dash
    .replace(/[^a-zA-Z0-9\s-]/g, "") // remove unsafe chars
    .replace(/\s+/g, "-")        // space → dash
    .replace(/-+/g, "-")         // multiple dash → single
    .toLowerCase()
    .trim();
}

/* ─────────────────────────────────────────────
   🔧 INTERNAL UTIL: SAFE FETCH WRAPPER
───────────────────────────────────────────── */
async function safeFetch(url) {
  const res = await fetch(url);
  let data;

  try {
    data = await res.json();
  } catch {
    throw new Error("Invalid server response");
  }

  if (!res.ok) {
    throw new Error(data?.message || "API request failed");
  }

  return data;
}

/* ─────────────────────────────────────────────
   📚 LIST PUBLISHED BLOGS
───────────────────────────────────────────── */
export async function getPublishedBlogs(opts = {}) {
  const params = new URLSearchParams();

  if (opts.page) params.set("page", opts.page);
  if (opts.limit) params.set("limit", opts.limit);
  if (opts.category) params.set("category", opts.category);
  if (opts.q) params.set("q", opts.q);
  if (opts.tag) params.set("tag", opts.tag);

  return safeFetch(`${PUBLIC_BLOGS}?${params.toString()}`);
}

/* ─────────────────────────────────────────────
   ⭐ FEATURED BLOGS
───────────────────────────────────────────── */
export async function getFeaturedBlogs() {
  return safeFetch(`${PUBLIC_BLOGS}/featured`);
}

/* ─────────────────────────────────────────────
   📄 BLOG BY SLUG (FIXED)
───────────────────────────────────────────── */
export async function getBlogBySlug(slug) {
  const cleanSlug = normalizeSlug(slug);
  return safeFetch(`${PUBLIC_BLOGS}/${encodeURIComponent(cleanSlug)}`);
}

/* ─────────────────────────────────────────────
   📄 BLOG BY ID
───────────────────────────────────────────── */
export async function getBlogByID(id) {
  return safeFetch(`${PUBLIC_BLOGS}/id/${id}`);
}